const StateInjection = Symbol();
export default StateInjection;
